import nookies from "nookies";
import { datadogLogs } from "@datadog/browser-logs";

import { PublicConfig } from "apps/website/config/public";
import {
  buildGtmDataUA,
  buildGtmDataGA4,
} from "apps/website/trackers/utils/gtm-builders";

import { PostCheckoutGTMTrigger, TriggerHandler } from "../types";
import { IGTMRechargeEvent } from "../../../types/gtm";

export const RC_PURCHASED = "rc_purchased";

export const pushToDataLayer = (data: unknown, errorMessage: string) => {
  if (globalThis.window?.dataLayer) {
    try {
      if (typeof data === "object" && data && "event" in data) {
        datadogLogs?.logger?.info("gtmHandler.pushToDataLayer window.dataLayer.push", {
          gtmDataEvent: data.event,
          formName: (data as IGTMRechargeEvent)?.ecommerce?.purchase?.actionField?.list || "MISSING_FORM",
          gtmData: data,
        });
      }
      globalThis.window.dataLayer?.push(data);
    } catch (e) {
      console.error(errorMessage);
      console.error(e);
    }
  }
};

export const gtmHandler: TriggerHandler<PostCheckoutGTMTrigger> = (
  _api,
  context,
  _trigger,
) => {
  if (!context.cookies.get(RC_PURCHASED)) {
    return true;
  }

  const data = context.sources?.firstOrder;

  if (!data) {
    return false;
  }

  const katkinCustomerId = context.query.get("katkinCustomerId");
  const flow = context.query.get("flow");

  if (!katkinCustomerId) {
    return false;
  }

  const { firstCharge } = data;
  const gtmData = buildGtmDataUA(
    firstCharge,
    katkinCustomerId,
    Array.isArray(flow) ? undefined : flow || undefined,
  );
  const gtmDataGA4 = buildGtmDataGA4(firstCharge);

  const { kktransactionId } = gtmData;

  if (!context.cookies.get(kktransactionId)) {
    nookies.set(null, kktransactionId, "true", {
      path: "/",
    });

    pushToDataLayer(gtmData, "gtmHandler failed to push gtmData");
    pushToDataLayer({ ecommerce: null }, "gtmHandler failed to clear ecommerce");
    pushToDataLayer(gtmDataGA4, "gtmHandler failed to push gtmDataGA4");

    context.posthog.capture("purchase", gtmDataGA4.ecommerce);

    context.cookies.remove(RC_PURCHASED, {
      path: "/",
      domain: PublicConfig.NEXT_PUBLIC_COOKIE_DOMAIN,
    });

    return true;
  }

  return false;
};
